var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgModulePower = function SvgModulePower(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#3B3F44",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    clipPath: "url(#modulePower_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.81 9.429a.86.86 0 0 0-.858-.857h-.857V6a1.715 1.715 0 0 0-1.714-1.714H3.238A1.714 1.714 0 0 0 1.523 6v12a1.714 1.714 0 0 0 1.715 1.715H20.38A1.715 1.715 0 0 0 22.095 18V15.43h.857a.857.857 0 0 0 .857-.857z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.97 7.986-2.842 3.84h3.717l-2.028 3.652"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "modulePower_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.667 0h24v24h-24z"
  })))));
};
export default SvgModulePower;